function BuyingAFlatIcon () {
  return(
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1229_4842)">
        <path d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z" fill="#EFF8FA"/>
        <path d="M28.5 30.88H43.75V30H29.7748L28.5 30.88Z" fill="#009AAB"/>
        <path d="M28.7224 32.2441C27.7804 35.2681 24.9604 37.4701 21.6244 37.4701C17.5204 37.4701 14.1904 34.1401 14.1904 30.0361C14.1904 25.9321 17.5204 22.6021 21.6244 22.6021C24.9604 22.6021 27.7924 24.5521 28.7584 27.9001" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.7224 32.2559H39.0604H45.8104V21.3359H42.4024V26.3339H39.2344V23.2319H35.8444V27.8939H28.7584" stroke="#333333" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M21.5882 32.94C23.2749 32.94 24.6422 31.5727 24.6422 29.886C24.6422 28.1994 23.2749 26.832 21.5882 26.832C19.9015 26.832 18.5342 28.1994 18.5342 29.886C18.5342 31.5727 19.9015 32.94 21.5882 32.94Z" fill="#FFC524"/>
      </g>
      <defs>
        <clipPath id="clip0_1229_4842">
          <rect width="60" height="60" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default BuyingAFlatIcon;